import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <UpdatesSection />
        <FaqSection />
        <TopicsSection />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <CarouselSection />
        <CommentsSection />
        <ContactSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}